<template>
  <!--
    小龙虾系列主题专区
   -->
  <div class="container">
    <!--顶部图-->
    <img
      src="https://yummy-common-test1.obs.cn-north-4.myhuaweicloud.com/app-themeArea/top.png"
      class="top-img"
    />
    <!--中部商品区域-->
    <div v-if="list.length > 0" class="content-wrap">
      <div class="item-box" @click="goDetail(list[0])">
        <img :src="list[0].litimgUrl" class="sr-img" />
        <div class="info-box">
          <div class="name-box">
            <span class="name">
              <svg>
                <use xlink:href="#priceText_4"></use>
                <text id="priceText_4" x="6" y="16" class="title">
                  <tspan>{{ list[0].title }}</tspan>
                  <tspan
                    :dx="isIOSPlatform ? 2 : 4"
                    :dy="isIOSPlatform ? 6: 8"
                    class="specification"
                  >{{ list[0].itemNetWeight }}</tspan>
                </text>
              </svg>
            </span>
          </div>
          <div class="price-box">
            <span class="price">
              <svg>
                <use xlink:href="#priceText"></use>
                <text id="priceText" x="2" y="4" class="price-text">
                  <tspan>￥{{ list[0].firstSku.lowestPriceStr }}</tspan>
                  <tspan dx="8" class="line-price">￥{{ list[0].firstSku.standardPriceStr }}</tspan>
                </text>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="item-box gali-mt" @click="goDetail(list[1])">
        <img :src="list[1].litimgUrl" class="gl-img" />
        <div class="info-box">
          <div class="name-box">
            <span class="name">
              <svg>
                <use xlink:href="#priceText_5"></use>
                <text id="priceText_5" :x="isIOSPlatform ? 174 : 180" y="22" class="title">
                  <tspan>{{ list[1].title }}</tspan>
                  <tspan
                    dx="6"
                    :dy="isIOSPlatform ? 8 : 12"
                    class="specification"
                  >{{ list[1].itemNetWeight }}</tspan>
                </text>
              </svg>
            </span>
          </div>
          <div class="price-box">
            <span class="price">
              <svg>
                <use xlink:href="#priceText_1"></use>
                <text :x="isIOSPlatform ? 174 : 180" y="22" id="priceText_1" class="price-text">
                  <tspan>￥{{ list[1].firstSku.lowestPriceStr }}</tspan>
                  <tspan :dx="isIOSPlatform ? 4 : 6" dy="4" class="line-price">￥{{ list[1].firstSku.standardPriceStr }}</tspan>
                </text>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="item-box mala-mt" @click="goDetail(list[2])">
        <img :src="list[2].litimgUrl" class="ml-img" />
        <div class="info-box">
          <div class="name-box">
            <span class="name">
              <svg>
                <use xlink:href="#priceText_3"></use>
                <text id="priceText_3" x="6" y="20" class="title">
                  <tspan>{{ list[2].title }}</tspan>
                  <tspan
                    :dx="isIOSPlatform ? 4 : 6"
                    :dy="isIOSPlatform ? 4 :6"
                    class="specification"
                  >{{ list[2].itemNetWeight }}</tspan>
                </text>
              </svg>
            </span>
          </div>
          <div class="price-box">
            <span class="price">
              <svg>
                <use xlink:href="#priceText_2"></use>
                <text id="priceText_2" x="6" y="12" class="price-text">
                  <tspan>￥{{list[2].firstSku.lowestPriceStr }}</tspan>
                  <tspan :dx="isIOSPlatform ? 0 : 6" class="line-price">￥{{ list[2].firstSku.standardPriceStr }}</tspan>
                </text>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--底部赠面-->
    <img
      v-if="isGive"
      src="https://yummy-common-test1.obs.cn-north-4.myhuaweicloud.com/app-themeArea/give-bottom.png"
      class="give-bottom"
    />
    <!--底部说明-->
    <img
      src="https://yummy-common-test1.obs.cn-north-4.myhuaweicloud.com/app-themeArea/explain-bottom.png"
      class="explain-bottom"
    />
  </div>
</template>

<script>
import { isWeixin, isAndroid, isIOS } from "@/utils";
import wx from "weixin-js-sdk";

export default {
  name: "index",
  data() {
    return {
      list: [],
      // 主题专区配置
      configData: {},
      // 配置中心数据
      configCenterData: {},
      shopMdCode: "",
      takeFoodMode: "",
      // 判断是否是微信平台
      isWeixinPlatform: false,
      // 判断是否是小程序中
      isInMiniApp: false,
      // 判断是否在浏览器中
      isInBrowser: false,
      // 判断是否在ios中
      isIOSPlatform: false
    };
  },
  computed: {
    // 是否赠面
    isGive() {
      // isgive 0-不赠面  1-赠面
      return this.$route.query?.isgive == 1;
    }
  },
  created() {
    // 处理url参数重复
    let shopcode = this.$route.query.shopMdCode;
    let taketype = this.$route.query.takeFoodMode || "1";
    if (Array.isArray(shopcode)) {
      this.shopMdCode = shopcode[0];
    } else {
      this.shopMdCode = shopcode;
    }
    if (Array.isArray(taketype)) {
      this.takeFoodMode = taketype[0];
    } else {
      this.takeFoodMode = taketype;
    }
    this.getConfigCenterData();
    this.getConfigData();
    this.getListData();
  },
  async mounted() {
    this.isWeixinPlatform = isWeixin();
    this.isInMiniApp = await this.isMiniProgram();
    this.isInBrowser = this.isBrowser();
    this.isIOSPlatform = isIOS()
    window.getShareConfig = this.getShareConfig;

    console.log("----环境----");
    console.log("isWeixin: ", isWeixin());
    console.log("isInApp: ", this.isInApp());
    console.log("isMiniProgram: ", this.isInMiniApp);
    console.log("isBrowser: ", this.isInBrowser);
  },
  methods: {
    // 获取页面列表数据
    getListData() {
      console.log("$route.query: ", this.$route.query);
      let params = {
        shopMdCode: this.shopMdCode,
        takeFoodMode: this.takeFoodMode,
      };
      this.$api.themezone.themezone
        .getItems(params)
        .then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              let data = res.data || {};
              this.list = data.firstSerias.firstFlow.items;
            } else {
              this.$toast({
                message: res.busMessage,
              });
            }
          } else {
            this.$toast({
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
          });
        });
    },
    // 判断是否在APP中打开
    isInApp() {
      // 根据 window.HandleShare 判断是否在APP中访问
      return !!window.HandleShare;
    },
    // 判断是否在微信浏览器或普通浏览器中打开
    isBrowser() {
      return !this.isInApp() && !this.isInMiniApp;
    },
    // 判断是否是微信浏览器还是小程序环境
    isMiniProgram() {
      // wx.miniProgram.getEnv是异步，所以封装在Promise中
      return new Promise((resolve) => {
        if (this.isWeixinPlatform) {
          return wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        }
        resolve(false);
      });
    },
    // 判断运行环境
    handleEnv(item) {
      // 在微信浏览器或普通浏览器打开跳转下载页
      if (this.isInBrowser) {
        if (isAndroid()) {
          window.location.href =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.abite.predishes.prehome";
        }
        if (isIOS()) {
          window.location.href = "https://www.abite.com/app/";
        }
        return false;
      }
      // 当小程序访问时，跳转商品详情页
      if (this.isInMiniApp) {
        wx.miniProgram.navigateTo({
          url: `/sub-menu/product/product?itemNo=${item.itemNo}&shopMdCode=${this.shopMdCode}&takeFoodMode=${this.takeFoodMode}`,
        });
        return false;
      }
      return true;
    },
    // 跳转详情页
    goDetail(item) {
      // 判断是否在浏览器或小程序中
      if (!this.handleEnv(item)) {
        return;
      }
      let itemNo = item.itemNo;
      let skuNo = item.firstSku ? item.firstSku.skuNo : "";
      // APP中
      if (this.isInApp()) {
        let obj = { itemNo, skuNo };
        let params = JSON.stringify(obj);
        console.log("params typeof: ", typeof params);
        console.log("跳详情--postMessage数据: ", params);
        GoProductDetail.postMessage(params);
        return;
      }
    },
    // 获取配置中心配置信息
    getConfigCenterData() {
      this.$api.themezone.common
        .getConfigCenter()
        .then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              let data = res.data || null;
              this.configCenterData = data;
            } else {
              this.$toast({
                message: res.busMessage,
              });
            }
          } else {
            this.$toast({
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
          });
        });
    },
    // 获取主题专区配置信息
    getConfigData() {
      this.$api.themezone.themezone
        .getConfig()
        .then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              let data = res.data || {};
              this.configData = data;
            } else {
              this.$toast({
                message: res.busMessage,
              });
            }
          } else {
            this.$toast({
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
          });
        });
    },
    // App分享
    getShareConfig() {
      let shareObj = {};
      // 判断配置中心是否打开了"小程序分享"开关
      if (this.configCenterData.miniProgramSharingSwitch === "true") {
        let h5ShareUrl = `${this.configData.wxminiCard.h5ShareUrl}&shopMdCode=${this.shopMdCode}&takeFoodMode=${this.takeFoodMode}`;
        let arr = h5ShareUrl.split("url=");
        let basePath = arr[0] || "";
        let encodeurl = arr[1] ? encodeURIComponent(arr[1]) : "";
        let shareUrl = `${basePath}url=${encodeurl}`;
        shareObj = {
          shareTitle: this.configData.wxminiCard.title,
          shareContent: this.configData.wxminiCard.context,
          litimgUrl: this.configData.wxminiCard.thumbnail,
          shareUrl: shareUrl,
          path: shareUrl,
        };
      } else {
        shareObj = {
          shareTitle: this.configData.h5Card.title,
          shareContent: this.configData.h5Card.context,
          litimgUrl: this.configData.h5Card.thumbnail,
          shareUrl: `${this.configData.h5Card.h5ShareUrl}&shopMdCode=${this.shopMdCode}&takeFoodMode=${this.takeFoodMode}`,
          path: "/",
        };
      }
      console.log("APP分享参数: ", JSON.stringify(shareObj));
      return JSON.stringify(shareObj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/font/topTaurusTi/topTaurus.css";
@import "~@/font/aliPuHuiTi/aliPuHuiTiRegular.css";

.container {
  background: #ea6c39;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 64px;
  .top-img {
    width: 100%;
    height: 788px;
  }
  .content-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
    width: 100%;
    .item-box {
      position: relative;
      .sr-img {
        width: 720px;
        height: 360px;
      }
      .gl-img {
        width: 688px;
        height: 340px;
      }
      .ml-img {
        width: 716px;
        height: 328px;
      }
      &.gali-mt {
        margin-top: -50px;
      }
      &.mala-mt {
        margin-top: -28px;
      }
      .info-box {
        position: absolute;
        .name-box {
          position: relative;
          .name {
            display: inline-block;
            .title {
              fill: #ffffff;
              font-family: "Top Taurus";
              font-size: 52px;
              transform: skewX(-18deg); // 倾斜
              .specification {
                display: inline-block;
                fill: #777777;
                stroke: none;
                font-family: "Ali PuHuiTi";
                font-size: 24px;
                font-weight: 500;
              }
            }
            svg {
              overflow: visible;
              height: 1em;
            }
            use {
              stroke: #1e1e1f; /*描边颜色*/
              stroke-width: 12px; /*控制描边宽度*/
              stroke-linejoin: round; /*描边转角处理方式*/
            }
          }
        }
        .price-box {
          position: relative;
          .price {
            position: absolute;
            top: 26px;
            left: -4px;
            margin: -6px 0 0 -14px;
            display: inline-block;
            width: 400px;
            .price-text {
              fill: #ffe746;
              font-family: "Ali PuHuiTi";
              font-size: 56px;
              transform: skewX(-18deg); // 倾斜
              font-weight: 600;
              .line-price {
                display: inline-block;
                fill: #777777;
                stroke: none;
                font-family: "Ali PuHuiTi";
                text-decoration: line-through;
                font-size: 24px;
                font-weight: 400;
              }
            }
            svg {
              overflow: visible;
              height: 1em;
            }
            use {
              stroke: #1e1e1f; /*描边颜色*/
              stroke-width: 12px; /*控制描边宽度*/
              stroke-linejoin: round; /*描边转角处理方式*/
            }
          }
        }
      }
      &:nth-child(1) {
        .info-box {
          top: 140px;
          left: 66px;
          .name-box {
            transform: rotate(-6.6deg); // 旋转
            margin-bottom: 34px;
          }
          .price-box {
            transform: rotate(-6.6deg); // 旋转
          }
        }
      }
      &:nth-child(2) {
        .info-box {
          top: 100px;
          //right: 106px;
          .name-box {
            transform: rotate(-5deg); // 旋转
            margin-bottom: 18px;
          }
          .price-box {
            transform: rotate(-5deg); // 旋转
          }
        }
      }
      &:nth-child(3) {
        .info-box {
          top: 50px;
          left: 30px;
          .name-box {
            transform: rotate(-5.3deg); // 旋转
            margin-bottom: 22px;
          }
          .price-box {
            transform: rotate(-5.3deg); // 旋转
          }
        }
      }
    }
  }
  .give-bottom {
    width: 690px;
    height: 432px;
    margin-top: -16px;
  }
  .explain-bottom {
    width: 408px;
    height: 94px;
    margin-top: 45px;
  }
}
</style>